// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Zone from "@insite/client-framework/Components/Zone";
import { get } from "@insite/client-framework/Services/ApiService";
import PageModule from "@insite/client-framework/Types/PageModule";
import { PageModel } from "@insite/client-framework/Types/PageProps";
import useHandleApiError from "@store/Framework/Common/Hooks/useHandleApiError";
import { getInvoicePayments } from "@store/Framework/Services/AccountBalanceService";
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import {
    InvoicePaymentDto,
    InvoicePaymentOption,
} from "@store/Framework/Store/Pages/AccountBalance/AccountBalanceReducer";
import Page from "@store/MobiusOverrides/Page/Page";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";
import React, { useEffect } from "react";

const AccountBalance: React.FC<PageModel> = ({ id }: PageModel) => {
    const dispatch = useBunzlDispatch();
    const apiErrorHandler = useHandleApiError();
    const bunzlDispatch = useBunzlDispatch();
    const { accountBalance, isLoading } = useAppSelector(state => {
        const toolkitState = toToolkitApplicationState(state);
        const accountBalance = toolkitState.bunzl.pages.accountBalance.accountBalance;
        const isLoading = toolkitState.bunzl.pages.accountBalance.isLoading;
        return { accountBalance, isLoading };
    });

    const setIsLoading = (isLoading: boolean) =>
        bunzlDispatch({ type: "Pages/AccountBalance/SetIsLoading", isLoading });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);

                const response = await apiErrorHandler(() => getInvoicePayments());

                dispatch({
                    type: "Pages/AccountBalance/LoadAccountBalance",
                    accountBalance: response,
                });
            } finally {
                setIsLoading(false);
            }
        };
        if (!isLoading && !accountBalance) {
            fetchData();
        }
    }, []);

    return (
        <Page>
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const pageModule: PageModule = {
    component: AccountBalance,

    definition: {
        supportsCategorySelection: true,
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};
export default pageModule;
